import { render, staticRenderFns } from "./GenvitePortalLink.vue?vue&type=template&id=3f13670e&"
import script from "./GenvitePortalLink.vue?vue&type=script&lang=js&"
export * from "./GenvitePortalLink.vue?vue&type=script&lang=js&"
import style0 from "./GenvitePortalLink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports